import React from "react";

const mainStyle = { fontSize: "8px", color: "#9b9a9a", paddingBottom: 2 };
const linkStyle = { fontSize: "8px", color: "#81bae5" };

/**
 * We're required by google to show this if we hid the recaprcha bedge
 */
export function GoogleLegal() {
  return (
    <div style={mainStyle}>
      This site is protected by reCAPTCHA and the Google
      <a style={linkStyle} href="https://policies.google.com/privacy">
        {" "}
        Privacy Policy
      </a>{" "}
      and
      <a style={linkStyle} href="https://policies.google.com/terms">
        {" "}
        Terms of Service
      </a>{" "}
      apply.
    </div>
  );
}
